import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-rent-sidebar',
  templateUrl: './edit-rent-sidebar.component.html',
  styleUrls: ['./edit-rent-sidebar.component.css']
})
export class EditRentSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
